<template>
  <div>
    <el-card>
      <el-form
        :model="list"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-form-item label="标题">
            <el-input placeholder="请输入内容" v-model="list.title" clearable />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="描述" prop="content">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="list.raffleDesc"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开始时间" prop="createDate">
              <el-date-picker
                v-model="list.startDate"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="结束时间" prop="createDate">
              <el-date-picker
                v-model="list.endDate"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  props: ["Changedata"],
  data() {
    return {
      list: [],
      id: "",
    };
  },
  mounted() {
    this.list = this.Changedata;
  },
  methods: {
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    upSuccess(file) {
      this.list.coverImg = file.entity;
    },
    submitAdd() {
      var startDate = this.formatDate(new Date(this.list.startDate));
      var endDate = this.formatDate(new Date(this.list.endDate));
      this.postAxios("/raffle/edit", {
        id: this.list.id,
        startDate: startDate,
        endDate: endDate,
        raffleDesc: this.list.raffleDesc,
        title:this.list.title
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  watch: {
    Changedata(newVal, oldVal) {
      this.list = newVal;
    },
  },
};
</script>